import { TypeAsnIncome } from '../../interfaces/Asn/TypeAsnIncome'
import {
  GET_TYPE_ASN_INCOME_EXITO,
  GET_TYPE_ASN_INCOME
} from '../types/typeAsnIncomeActionsTypes'

export type TypeAsnIncomeAction =
  | TypeAsnIncomesAction
  | TypeAsnIncomesActionAsync

// Esto va a REDUX
export interface TypeAsnIncomesAction {
  type: typeof GET_TYPE_ASN_INCOME_EXITO
  typeAsnIncome: TypeAsnIncome[] | undefined
  error: string | undefined
}

export const getTypeAsnIncomeAction = (
  typeAsnIncome?: TypeAsnIncome[],
  error?: string
): TypeAsnIncomesAction => {
  return {
    type: GET_TYPE_ASN_INCOME_EXITO,
    typeAsnIncome: typeAsnIncome,
    error
  }
}

// Esto va a SAGA
export interface TypeAsnIncomesActionAsync {
  type: typeof GET_TYPE_ASN_INCOME
}

export const getTypeAsnIncomeActionAsync = (): TypeAsnIncomesActionAsync => {
  return {
    type: GET_TYPE_ASN_INCOME
  }
}
